import React, { useCallback, useMemo } from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/styles'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import styles from './styles'

interface ISearchMenuList {
	searchTabs: {
		All: {
			link: string
			component: any
			path: string
			totalCount: number
		}
		Employers: {
			link: string
			component: any
			path: string
		}
		People: {
			link: string
			component: any
			path: string
		}
		Articles: {
			link: string
			component: any
			path: string
		}
		Teams: {
			link: string
			component: any
			path: string
		}
		Jobs: {
			link: string
			component: any
			path: string
		}
	}
	handleSearchSection: Function
}

const useStyles = makeStyles(styles)

const SearchMenuList: React.FunctionComponent<ISearchMenuList> = ({
	searchTabs,
	handleSearchSection,
}) => {
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const {
		state,
		pathname,
	}: {
		state: { seeEmployersAndTeamsSection?: boolean }
		pathname: string
	} = useLocation()
	const currentMenuItem: string | undefined = useMemo(() => {
		return Object.keys(searchTabs).find(item =>
			matchPath(pathname, {
				// @ts-ignore
				path: `/${i18n.language}/search${searchTabs[item].link}`,
				exact: true,
			}),
		)
	}, [i18n.language, pathname, searchTabs])

	// TODO: in handleChange, event.target.value returns undefined

	const handleChange = useCallback(
		(
			event: React.ChangeEvent<{
				name?: string | undefined
				value: unknown
			}>,
		) => {
			handleSearchSection(
				// @ts-ignore
				searchTabs[event.target.value].link,
			)
		},
		[handleSearchSection, searchTabs],
	)

	const allCount = searchTabs?.All?.totalCount

	return (
		<div className={classes.container}>
			<FormControl
				variant="outlined"
				classes={{ root: classes.formControl }}
			>
				<InputLabel id="menuList">{t('Section')}</InputLabel>
				<Select
					labelId="menuList"
					value={currentMenuItem}
					onChange={handleChange}
					label={t('Section')}
					classes={{ root: classes.select }}
				>
					{Object.keys(searchTabs)
						?.filter((item: string) => {
							if (state && state.seeEmployersAndTeamsSection) {
								if (item === 'Employers' || item === 'Teams') {
									return true
								} else {
									return false
								}
							} else {
								return true
							}
						})
						?.map((item: any, index: number) => {
							return (
								<div>
									<MenuItem
										value={item}
										key={`menu_list_${index}`}
									>
										<Link
											className={classes.link}
											key={`tab_${index}`}
											to={{
												// @ts-ignore
												pathname: `/${i18n.language}/search${searchTabs[item].link}`,
												state: {
													seeEmployersAndTeamsSection:
														state &&
														state.seeEmployersAndTeamsSection
															? true
															: undefined,
												},
											}}
										>
											<span>
												{t(
													// @ts-ignore
													item,
												)}
											</span>
										</Link>
										{
											//@ ts-ignore
											!allCount &&
											state?.seeEmployersAndTeamsSection ===
												true ? null : (
												<div
													className={
														classes.resultsCount
													}
												>
													{t('Total')}
													{': '}
													{
														// @ts-ignore
														searchTabs[item]
															.totalCount
													}
												</div>
											)
										}
									</MenuItem>
								</div>
							)
						})}
				</Select>
			</FormControl>
		</div>
	)
}

export default SearchMenuList
